import React, {useCallback, useEffect, useState} from 'react';
import {Space, Input, Select, Image, Button} from 'antd'
import CoverUploader from '../../components/Uploader'
import {PlusOutlined} from "@ant-design/icons";
import {SectionDict, GradeDict, SubjectDict, VersionDict} from '../../util/dict'
import TeacherItem from "../teacher/item";
import TeacherModal from "../teacher/modal"

export default function ({onUpdate, onSave, onCancel, data = {}, lecturerList=[]}) {
    const [courseName, setCourseName] = useState(data.courseName)
    const [coverImg, setCoverImg] = useState(data.coverImg)

    //课程标签
    const [sectionCode, setSectionCode] = useState()
    const [gradeCode, setGradeCode] = useState()
    const [subjectCode, setSubjectCode] = useState()
    const [versionCode, setVersionCode] = useState()
    const [customLabel, setCustomLabel] = useState()
    const [teacherList, setTeacherList] = useState(lecturerList)

    useEffect(() => {
        if (data.courseId) {
            setCourseName(data.courseName)
            setCoverImg(data.coverImg)
            setSectionCode(data.sectionCode||undefined)
            setGradeCode(data.gradeCode||undefined)
            setSubjectCode(data.subjectCode||undefined)
            setVersionCode(data.versionCode||undefined)
            setCustomLabel(data.label.replace(/\|/g,';'))
            setTeacherList(lecturerList || [])
        } else {
            setCourseName()
            setCoverImg()
            setSectionCode()
            setGradeCode()
            setSubjectCode()
            setVersionCode()
            setCustomLabel()
            setTeacherList([])
        }
    }, [data.courseId])

    const onCover = useCallback((url) => {
        setCoverImg(url)
    })

    const [showTeacherModal, setShowTeacherModal] = useState(false)
    const openTeacherModal = useCallback(() => {
        setShowTeacherModal(true)
    })
    const onTeacherModalClose = useCallback((data) => {
        setShowTeacherModal(false)
        if (data) {
            let index = teacherList.findIndex((item) => { // 从消息列表删除
                return item.lecturerId === data.lecturerId
            })
            if (index === -1) {
                setTeacherList([data, ...teacherList])
            }
        }
    })

    const removeTeacher = useCallback((id) => {
        let index = teacherList.findIndex((item) => { // 从消息列表删除
            return item.lecturerId === id
        })
        teacherList.splice(index, 1)
        setTeacherList([...teacherList])
    })

     useEffect(()=>{
         onUpdate && onUpdate({
             courseName,
             coverImg,
             lecturerIds: teacherList.map(teacher=>teacher.lecturerId),
             sectionCode,
             gradeCode,
             subjectCode,
             versionCode,
             labels: customLabel ? customLabel.split(/[；;]/):[]
         })
     },[courseName,coverImg,sectionCode,gradeCode,subjectCode,versionCode,customLabel,teacherList])

    const save = useCallback(() => {
        onSave && onSave({
            courseName,
            coverImg,
            lecturerIds: teacherList.map(teacher => teacher.lecturerId),
            sectionCode,
            gradeCode,
            subjectCode,
            versionCode,
            labels: customLabel ? customLabel.split(/[；;]/) : []
        }, teacherList)
    })
    const cancel = useCallback(() => {
        onCancel && onCancel()
    })

    return <>
        <div className="white-bg pdv40 pdh32" style={{minWidth: 800, maxWidth: 1200}}>
            <div className="flexbox">
                <div className="flex1">
                    <div className="required bold">课程名称</div>
                    <div className="mgb20 pdv12">
                        <Input placeholder="请输入课程名称"
                               maxLength={80}
                               value={courseName}
                               onChange={(e) => setCourseName(e.target.value)}/>
                    </div>

                    <div className="bold">课程标签：</div>
                    <div className="pdv12">
                        <Space wrap>
                            <Select
                                allowClear
                                placeholder="请选学段"
                                style={{width: 140}}
                                fieldNames={{value: 'code', label: 'name'}}
                                options={SectionDict}
                                value={sectionCode}
                                onChange={value => setSectionCode(value)}
                            />
                            <Select
                                allowClear
                                placeholder="请选年级"
                                style={{width: 140}}
                                fieldNames={{value: 'code', label: 'name'}}
                                options={GradeDict}
                                value={gradeCode}
                                onChange={value => setGradeCode(value)}
                            />
                            <Select
                                allowClear
                                placeholder="请选学科"
                                style={{width: 140}}
                                fieldNames={{value: 'code', label: 'name'}}
                                options={SubjectDict}
                                value={subjectCode}
                                onChange={value => setSubjectCode(value)}
                            />
                            <Select
                                allowClear
                                placeholder="请选教材版本"
                                style={{width: 140}}
                                fieldNames={{value: 'code', label: 'name'}}
                                options={VersionDict}
                                value={versionCode}
                                onChange={value => setVersionCode(value)}
                            />
                        </Space>
                        <div className="pdv12">
                            <Input placeholder="自定义标签，多个标签用分号隔开"
                                   maxLength={120}
                                   value={customLabel}
                                   onChange={(e) => setCustomLabel(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div style={{width: '360px'}} className="pd12 mgl80">
                    <div className="required bold">课程封面</div>
                    <div className="pdv12">
                        <CoverUploader type={2} onResult={onCover}>
                            {coverImg && <Image src={coverImg} preview={false} style={{width: 200, height: 120}}/>}
                        </CoverUploader>
                        <div className="gray">支持jpg、png、jpeg格式，尺寸为800px *450px</div>
                    </div>
                </div>
            </div>
            <div className="pdv12">
                <div className="mgb12 bold">讲师信息</div>
                <div className="flexbox">
                    <div className="flexbox flex-column align-center justify-center cursor mgr12"
                         style={{width: 100, height: 70, border: "1px dashed #cccccc", borderRadius: 4}}
                         onClick={openTeacherModal}
                    >
                        <PlusOutlined className="fts-24 gray"/>
                        <span>添加</span>
                    </div>
                    <div className="flex1">
                        <Space className="flexbox wrap">
                            {teacherList.map(teacher => <TeacherItem
                                key={teacher.lecturerId}
                                data={teacher}
                                onClose={(item) => removeTeacher(item.lecturerId)}
                            />)}

                        </Space>
                    </div>
                </div>
            </div>
            {onSave && <div className="text-right pdh32">
                <Space>
                    <Button  onClick={cancel}>取消</Button>
                    <Button type="primary"  onClick={save}>保存</Button>
                </Space>
            </div>}
        </div>
        <TeacherModal isShow={showTeacherModal} onClose={onTeacherModalClose}/>
    </>
}







